/** WINIA Green View 산소발생기 — 제품 디자인 케이스 데이터 */

export const GREEN_VIEW_SLUG = 'green-view'

export const GREEN_VIEW_SHEET_IMG = '/assets/img/design/green-view-sheet.png'
export const GREEN_VIEW_PROCESS_POSITIONING_IMG =
    '/assets/img/design/green-view-process-positioning.png'
export const GREEN_VIEW_PROCESS_CONCEPT_IMG =
    '/assets/img/design/green-view-process-concept.png'
export const GREEN_VIEW_LIFESTYLE_IMG = '/assets/img/design/green-view-lifestyle.png'

export const greenViewPortfolioCard = {
    slug: GREEN_VIEW_SLUG,
    title: 'WINIA Green View',
    excerpt:
        '식물과 함께 숨 쉬는 산소발생기 — 식물재배·산소 공급·실내 정화를 한 볼륨에 담은 홈 가든 가전입니다.',
    image: GREEN_VIEW_LIFESTYLE_IMG,
    imageAlt: 'WINIA Green View 산소발생기 — 거실 인테리어 라이프스타일 컷',
    year: '2023',
    tags: ['산소발생기', '플랜터', '홈 가든'],
}

const greenViewShowcases = [
    {
        id: 'green-view-process',
        kicker: 'Design process',
        title: '포지셔닝 · 스케치 · 3D',
        tagline: '산소발생기 · Green View',
        image: GREEN_VIEW_PROCESS_POSITIONING_IMG,
        imageAlt:
            'Green View 디자인 프로세스 — 개발 컨셉, 디자인 포지셔닝 차트, 스케치·3D 렌더',
        description: [
            '식물이 발생시키는 산소와 산소 발생기에서 생성되는 산소가 상호 작용해 집 안에서 상쾌한 공기를 만드는 컨셉을 제안했습니다. 무드 이미지와 포지셔닝 차트로 고가형·심플 디자인을 개발 목표로 설정했습니다.',
            '스케치 단계에서 LED·내부 구조·외형을 도출하고, 투명 실린더·상부 링·하부 그릴 등 3D 렌더로 볼륨을 검증했습니다.',
        ],
        features: [
            {
                title: '개발 컨셉',
                text: '식물재배와 동시에 신선한 산소를 공급하는 하이브리드 홈 가든 가전입니다.',
            },
            {
                title: '디자인 포지셔닝',
                text: '저가형 심플 다수 시장에서 고가형·심플·기능 차별화 포지션을 목표로 했습니다.',
            },
            {
                title: '스케치 · 3D',
                text: '산소발생기 스케치를 통해 외형·내부 배치를 정리하고 KeyShot으로 검증했습니다.',
            },
            {
                title: '기능 구역',
                text: '재배 트레이·중앙 컬럼·산소 포집·상부 송출 구조를 단계별로 시각화했습니다.',
            },
        ],
    },
    {
        id: 'green-view-concept-mockup',
        kicker: 'Concept · Mockup',
        title: '디자인 컨셉 · 목업',
        tagline: '산소공급 & 식물케어',
        image: GREEN_VIEW_PROCESS_CONCEPT_IMG,
        imageAlt:
            'Green View — 산소 발생 홀·식물 성장 LED·산소 포집 통 콜아웃 및 꽃 목업 3컷',
        description: [
            '상부 링의 산소 발생 홀, 식물 광합성용 LED, 하단 투명 산소 포집 통을 콜아웃으로 설명했습니다. WINIA 로고가 들어간 상부 링과 양측 대형 잎 식물 재배 트레이가 핵심 실루엣입니다.',
            '목업 제작 단계에서는 실제 꽃·식물을 심어 산소 공급·식물 케어 사용 시나리오를 검증했습니다.',
        ],
        features: [
            {
                title: '산소 발생 홀',
                text: '상부 링 주변에서 공기질 개선을 위한 산소를 발생·분산합니다.',
            },
            {
                title: '성장 LED',
                text: '식물이 광합성에 필요한 에너지를 얻도록 상부에서 조명을 제공합니다.',
            },
            {
                title: '산소 포집 통',
                text: '투명 실린더로 공기 중 산소를 모아 저장·표시하는 장치를 전면에 배치했습니다.',
            },
            {
                title: '물리 목업',
                text: '산소공급·식물케어 통합 형태를 꽃재배 목업으로 사용자 경험을 확인했습니다.',
            },
        ],
    },
    {
        id: 'green-view-lifestyle',
        kicker: 'Lifestyle',
        title: 'Green View',
        tagline: '집 안의 숲',
        image: GREEN_VIEW_LIFESTYLE_IMG,
        imageAlt: 'WINIA Green View — 우드 사이드보드 위 거실 인테리어 라이프스타일',
        description: [
            '라이트 그레이 본체와 우드 가구·연한 벽면 톤으로 모던 거실에 자연스럽게 놓이도록 연출했습니다. 양측 대형 잎 식물과 중앙 WINIA 컬럼이 「집 안의 숲」 이미지를 전달합니다.',
            '부드러운 자연광·은은한 그림자로 프리미엄 홈 가전 감성을 강조했습니다.',
        ],
        features: [
            {
                title: '인테리어 조화',
                text: '미니멀 화이트·그레이 톤으로 거실·서재 등 생활 공간에 맞춥니다.',
            },
            {
                title: '식물 재배',
                text: '양측 넓은 트레이로 관상·정화용 식물을 함께 키울 수 있습니다.',
            },
            {
                title: '브랜드 WINIA',
                text: '중앙 컬럼 워드마크로 제품군 인지를 고정했습니다.',
            },
            {
                title: '공기·녹색 경험',
                text: '식물의 아름다움과 실내 공기 정화를 동시에 누리는 라이프스타일을 제시합니다.',
            },
        ],
    },
]

const greenViewProcessPhases = [
    {
        id: 'concept',
        title: '콘셉트 & 리서치',
        lede: '식물과 함께 숨 쉰다는 콘셉트의 산소발생기입니다.',
        body: '식물재배와 동시에 신선한 산소를 공급하고, 실내 공기 정화로 집 안의 숲을 느끼게 하는 제품을 목표로 했습니다. 시장 포지셔닝에서 고가형·심플·기능 차별화 영역을 설정했습니다.',
    },
    {
        id: 'form',
        title: '형태 & 기능 구역',
        lede: '260×450×300(mm) 스케일의 양측 재배·중앙 컬럼·상부 링 구조입니다.',
        body: 'ABS 본체에 투명 산소 포집 통, 상부 산소 발생 홀, 식물 성장 LED, 양측 플랜터 트레이를 배치했습니다. 스케치·3D로 내부 LED·통풍·재배 깊이를 검증했습니다.',
    },
    {
        id: 'mockup',
        title: '목업 & 검증',
        lede: '디자인 컨셉 렌더와 꽃·식물 목업으로 사용 시나리오를 확인했습니다.',
        body: '산소공급·식물케어 통합 UX를 물리 목업으로 테스트하고, 상부 링·재배 트레이 비율을 조정했습니다.',
    },
    {
        id: 'viz',
        title: '시각화',
        lede: 'Rhinoceros·KeyShot·Photoshop으로 시트·프로세스·라이프스타일 렌더를 제작했습니다.',
        body: '제품 시트, 디자인 프로세스 보드, 컨셉·목업 콜라주, 거실 라이프스타일 컷으로 갤러리·상세·마케팅 산출물을 구성했습니다.',
    },
]

export const greenViewDesignCase = {
    pageTitle: 'WINIA Green View 산소발생기',
    masthead: 'Green View',
    mastheadSub: 'Oxygen Generator',
    showcaseSectionTitle: '제품 특징 · 디자인 프로세스',
    metaDescription:
        'WINIA Green View 산소발생기 — 식물재배·산소 공급·실내 정화, 디자인 프로세스·목업, Rhino·KeyShot 제품 디자인 사례입니다.',
    meta: {
        client: 'WINIA',
        year: '2023',
        scope: '제품 디자인 · Rhinoceros · KeyShot · Photoshop',
        size: '260 × 450 × 300 (mm)',
        material: 'ABS',
    },
    intro: {
        lead: '식물과 함께 숨 쉰다는 콘셉트의 산소발생기입니다. 식물재배와 동시에 신선한 산소를 공급합니다.',
        left: '식물의 아름다움을 즐기며 실내 공기 정화를 통해 집 안의 숲을 느낄 수 있도록, 양측 대형 재배 트레이·중앙 WINIA 컬럼·상부 링 조명·하단 산소 포집 통을 한 볼륨에 통합했습니다.',
        right: '제품 시트로 콘셉트·스펙을, 프로세스 보드로 포지셔닝·스케치·3D를, 컨셉·목업 보드로 기능 콜아웃과 물리 검증을, 라이프스타일 컷으로 거실 배치를 각각 전달합니다.',
    },
    hero: {
        src: GREEN_VIEW_SHEET_IMG,
        alt: 'WINIA Green View 산소발생기 제품 시트 — Green View, 스펙·3D 렌더',
    },
    productShowcases: greenViewShowcases,
    processPhases: greenViewProcessPhases,
    deliverables: [
        '식물·산소 하이브리드 콘셉트·포지셔닝·스토리보드',
        'Rhinoceros 3D 모델 및 KeyShot 렌더',
        '기능 콜아웃·LED·산소 포집 통 시안',
        '물리 목업(산소공급·식물케어) 검증',
        '제품 스펙 시트(260×450×300 mm · ABS · 2023)',
        'Photoshop 프로세스 보드·라이프스타일 컷',
    ],
    outro: [
        '가전과 녹색 생활을 결합하면 공기·식물·감성 경험을 한 제품으로 전달할 수 있습니다.',
        'Green View는 고가형 심플 포지션과 목업 검증까지 이어진 홈 가든 제품 디자인 사례입니다.',
        '코담디자인은 생활·웰니스 가전의 제품 디자인·프로세스·렌더 시각화를 지원합니다.',
    ],
}
